var SingleSelectGroupSize;

(function (SingleSelectGroupSize) {
  SingleSelectGroupSize[SingleSelectGroupSize["Small"] = 12] = "Small";
  SingleSelectGroupSize[SingleSelectGroupSize["Medium"] = 16] = "Medium";
  SingleSelectGroupSize[SingleSelectGroupSize["Large"] = 24] = "Large";
  SingleSelectGroupSize[SingleSelectGroupSize["XLarge"] = 32] = "XLarge";
})(SingleSelectGroupSize || (SingleSelectGroupSize = {}));

var SingleSelectGroupType;

(function (SingleSelectGroupType) {
  SingleSelectGroupType["Primary"] = "BUTTON/PRIMARY";
  SingleSelectGroupType["Secondary"] = "BUTTON/SECONDARY";
  SingleSelectGroupType["Tertiary"] = "BUTTON/TERTIARY";
  SingleSelectGroupType["PrimaryPill"] = "BUTTON/PRIMARY_PILL";
  SingleSelectGroupType["SecondaryPill"] = "BUTTON/SECONDARY_PILL";
  SingleSelectGroupType["TertiaryPill"] = "BUTTON/TERTIARY_PILL";
})(SingleSelectGroupType || (SingleSelectGroupType = {}));

export { SingleSelectGroupSize, SingleSelectGroupType };
